import React from 'react';

/** Minimal chevron for gallery / carousel controls (replaces Unicode ❮ ❯). */
export default function ChevronIcon({ direction = 'left', className = '' }) {
  const rotate = direction === 'right' ? 180 : 0;
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      style={{ transform: `rotate(${rotate}deg)` }}
    >
      <path d="M15 6l-6 6 6 6" />
    </svg>
  );
}
